import React, { useRef, useState } from 'react';
import { useDispatch } from 'react-redux';

import { changeEaState } from '@store/actions/eaAction';

import SatSignPad from '@components/common/satUI/SatSignPad';
import SatButton from '@components/common/satUI/SatButton';

const PracticeSignaturePopup = props => {
  const {
    completePage,
    practiceSignName,
    setPracticeSignName,
    practiceSignature,
    setPracticeSignature,
    ownerPrspInfo,
    onClickNext,
    onClose,
  } = props;

  const dispatch = useDispatch();

  const canvasNameRef = useRef();
  const canvasSignRef = useRef();

  const [isErrorVisible, setIsErrorVisible] = useState(false);

  const handleButtonClick = () => {
    // 성명, 서명 저장

    if (!practiceSignName || !practiceSignature) {
      // disabled 상태에서 버튼 클릭
      setIsErrorVisible(true);
    } else {
      callbackSuccess(true);
    }
  };

  const callbackSuccess = type => {
    if (type) {
      onClose();
      const completePages = [...completePage, 3];
      dispatch(
        changeEaState({
          type: 'completePage',
          data: [...new Set(completePages)],
        }),
      );
      onClickNext();
    }
  };

  return (
    <React.Fragment>
      <div className="cont">
        <h3 className="layer-tit2">전자문서 서명 동의</h3>
        <div className="consent-scroll" id="signPadScroll">
          <div className="info-box bg-yellow">
            <p className="text-info3 asterisk-type">
              등록하신 고객의 성명과 서명은 이후 모든 청약서류에 붙여넣기가
              가능합니다.
            </p>
            <p className="text-info3 asterisk-type">
              주요 내용 확인 후, 고객 성명 및 서명란에 &lsquo;성명/서명
              붙여넣기&rsquo;를 선택하면 됩니다.
            </p>
          </div>
          <div className="sign-pad-wrap">
            <SatSignPad
              canvasRef={canvasNameRef}
              name={ownerPrspInfo.name}
              title={'계약자/피보험자 성명 입력'}
              error={
                isErrorVisible && !practiceSignName
                  ? '성명을 입력해주세요.'
                  : ''
              }
              onChange={data => setPracticeSignName(data)}
              signData={completePage.includes(3) ? practiceSignName : ''}
            />
            <SatSignPad
              canvasRef={canvasSignRef}
              name={'서명'}
              title={'계약자/피보험자 서명 입력'}
              error={
                isErrorVisible && !practiceSignature
                  ? '서명을 입력해주세요.'
                  : ''
              }
              onChange={data => setPracticeSignature(data)}
              signData={completePage.includes(3) ? practiceSignature : ''}
            />
          </div>
        </div>
      </div>
      <div className="layer-footer">
        <SatButton
          styleClass={`btn-s blue btn-wide ${
            !practiceSignName || !practiceSignature ? 'disabled' : ''
          }`}
          label={'확인'}
          onClick={() => handleButtonClick()}
        />
      </div>
    </React.Fragment>
  );
};

export default PracticeSignaturePopup;
